import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
export const rules = {
  
}
